import eventify from 'ngraph.events';

// we are going to use this as a global message bus inside the app.
export default eventify({});


// WEBPACK FOOTER //
// ./src/lib/bus.js